import { connectAggregationToObservable } from '@pendo/agg-connect';
import { of } from 'rxjs';
import PageFeatureAlertsAggregationCount from '../../../pages/pages-alerts/aggregations/page-feature-alerts-count.aggregation';
import { updateSubscriptions, fetchSubscriptions, filterPageFeatureData } from './pages-alerts.utils';
import get from 'lodash/get';

const PagesAlerts = {
    namespaced: true,
    state: {
        pagesAlertsCount: 0,
        subscriptionApps: [],
        subscriptionUpdateStatus: true,
        subscriptionDisableStatus: false,
        pageFeatureAlerts: [],
    },
    mutations: {
        setPagesAlertsCount (state, { pagesAlertsCount }) {
            state.pagesAlertsCount = pagesAlertsCount;
        },
        setPageFeatureAlerts (state, { pageFeatureAlerts }) {
            state.pageFeatureAlerts = pageFeatureAlerts;
        },
        setSubscription (state, subscriptions) {
            state.subscriptionApps = [...subscriptions] || [];
        },
        setSubscriptionUpdateStatus (state, status) {
            state.subscriptionUpdateStatus = status;
        },
        setSubscriptionDisableStatus (state, status) {
            state.subscriptionDisableStatus = status;
        },
    },
    actions: {
        fetchPagesAlertsCount ({ commit }, { createdAt }) {
            const res = connectAggregationToObservable(
                PageFeatureAlertsAggregationCount,
                of({ appId: ['expandAppIds("mobile-retro")'], createdAt }),
            );
            res.subscribe(({ value }) => {
                if (value) {
                    commit('setPagesAlertsCount', { pagesAlertsCount: get(value[0], 'totalBroken') });
                }
            });
        },
        async fetchSubscription ({ commit }) {
            try {
                const response = await fetchSubscriptions();
                commit('setSubscription', response);
            } catch (error) {
                commit('setSubscriptionDisableStatus', true);
            }
        },
        async updateSubscription ({ state, commit }, apps) {
            try {
                await updateSubscriptions(state.subscriptionApps, apps);
                commit('setSubscription', apps);
            } catch (error) {
                commit('setSubscriptionUpdateStatus', false);
            }
        },
        fetchPageFeatureAlerts ({ commit }, value) {
            commit('setPageFeatureAlerts', { pageFeatureAlerts: filterPageFeatureData(value) });
        },
    },
    getters: {
        getPagesAlertsCount: (state) => state.pagesAlertsCount,
        getPageFeatureAlerts: (state) => state.pageFeatureAlerts,
        getUserSubscriptions: (state) => state.subscriptionApps,
        isUserSubscribe: (state) => state.subscriptionApps.length > 0,
        subscriptionUpdateStatus: (state) => state.subscriptionUpdateStatus,
        subscriptionDisableStatus: (state) => state.subscriptionDisableStatus,
    },
};

export default PagesAlerts;
